<template>
  <div class="cm-container test-result" :class="{'vresults': vresult}">
    <p class="result-desc text-center">恭喜你，完成{{unitName}}！</p>
    <ul class="result-analysic">
      <li class="analysic-item text-center">
        <div class="radial">
          <span class="circle left"><i :style="{transform: `rotate(${countAnalysicLeft})`}"></i></span>
          <span class="circle right"><i :style="{transform: `rotate(${countAnalysicRight})`}"></i></span>
        </div>
        <div class="analysic-block">
          <div class="analysic-text">
            <p>做题结果为</p>
            <p class="target">{{result.correct_nr}}/{{result.total_nr}}</p>
          </div>
        </div>
        <p class="analysic-desc">{{result.tip_result}}</p>
      </li>
      <li class="analysic-item text-center">
        <div class="radial">
          <span class="circle left"><i :style="{transform: `rotate(${timeAnallysicLeft})`}"></i></span>
          <span class="circle right"><i :style="{transform: `rotate(${timeAnallysicRight})`}"></i></span>
        </div>
        <div class="analysic-block">
          <div class="analysic-text">
            <p>共计用时</p>
            <p class="target">{{result.spanTime|s2min}}</p>
          </div>
        </div>
        <p class="analysic-desc">建议用时：{{result.tip_time|s2min}}</p>
      </li>
      <!-- <li class="analysic-item text-center">
        <div class="radial">
          <span class="circle left"><i :style="{transform: `rotate(${levelAnalysicLeft})`}"></i></span>
          <span class="circle right"><i :style="{transform: `rotate(${levelAnalysicRight})`}"></i></span>
        </div>
        <div class="analysic-block">
          <div class="analysic-text">
            <p>等级</p>
            <p class="target">{{result.level}}</p>
          </div>
        </div>
        <p class="analysic-desc">{{result.tip_level}}</p>
      </li> -->
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    unitName: {
      type: String,
      default: ''
    },
    result: {
      type: Object,
      default: () => {}
    },
    vresult: true
  },
  computed: {
    countTotalDegree(){
      return (this.result.correct_nr/this.result.total_nr).toFixed(2);
    },
    countAnalysicLeft(){
      return this.countPercentLeft(this.countTotalDegree);
    },
    countAnalysicRight(){
      return this.countPercentRight(this.countTotalDegree);
    },
    timeTotalDegree(){
      return (this.result.spanTime/this.result.tip_time).toFixed(2);
    },
    timeAnallysicLeft(){
      return this.countPercentLeft(this.timeTotalDegree);
    },
    timeAnallysicRight(){
      return this.countPercentRight(this.timeTotalDegree);
    },
    levelTotalDegree(){
      return (this.result.level_percent / 100).toFixed(2);
    },
    levelAnalysicLeft(){
      return this.countPercentLeft(this.levelTotalDegree);
    },
    levelAnalysicRight(){
      return this.countPercentRight(this.levelTotalDegree);
    }
  },
  methods: {
    countPercentLeft(data){
      return `${(data > 0.5 ? 0.5 : data)*360-180}deg`;
    },
    countPercentRight(data){
      return `${(data > 0.5 ? data - 0.5 : 0)*360-180}deg`;
    }
  }
}
</script>
<style lang="sass" scoped>
  .vresults
    background-image: none
    padding-top: 0px
</style>

